import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';

import axios from '../../services/MyAxios';

// noinspection ES6CheckImport
import ResellerForm from './ResellerForm';

import Card from 'crm/elements/common/Card';

function ResellerCreate() {
    const [errors, setErrors] = useState([]);
    const history = useHistory();
    const url = '/crea/api/reseller';

    const handleCreateReseller = (newReseller) => {
        axios
            .post(url, newReseller)
            .then(() => {
                history.push('/resellers');
            })
            .catch((error) => {
                setErrors(error.response.data.errors);
            });
    };

    return (
        <Card title="Create new reseller">
            <ResellerForm errors={errors} action={handleCreateReseller} />
        </Card>
    );
}

export default ResellerCreate;
